import type { PlcManufacturerFaultLibrary } from "./types";

export const beckhoffFaultLibrary: PlcManufacturerFaultLibrary = {
  manufacturer_id: "beckhoff",
  manufacturer_name: "Beckhoff",
  faults: [
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "CX2020 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "CX2020 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "CX2020 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Watchdog مال CX2020 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Scan Time مال CX2020 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "حرارة CX2020 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Battery/Backup مال CX2020 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Memory Error في CX2020",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "بيانات Retain مال CX2020 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "ساعة RTC مال CX2020 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Firmware مال CX2020 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Project داخل CX2020 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Download إلى CX2020 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Upload من CX2020 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX2020",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX2020",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX2020",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Ethernet Link مال CX2020 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX2020 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX2020 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX2020 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Module مفقود من تكوين CX2020",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX2020",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX2020",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Digital Input ما يقرا على CX2020",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Input على CX2020 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Output على CX2020 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Analog Input على CX2020 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Analog Input على CX2020 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Analog Reading على CX2020 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Analog Output من CX2020 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "High Speed Counter على CX2020 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Encoder ويا CX2020 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Force/Override فعال على CX2020",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX2020",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX2020 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Motion/Axis command من CX2020 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "PID داخل CX2020 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "CX2020 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "CX2020 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "بيانات داخل CX2020 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2020-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2020",
      code: null,
      title_ar: "Diagnostic/Event log مال CX2020 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2020",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2020", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "CX2030 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "CX2030 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "CX2030 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Watchdog مال CX2030 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Scan Time مال CX2030 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "حرارة CX2030 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Battery/Backup مال CX2030 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Memory Error في CX2030",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "بيانات Retain مال CX2030 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "ساعة RTC مال CX2030 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Firmware مال CX2030 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Project داخل CX2030 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Download إلى CX2030 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Upload من CX2030 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX2030",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX2030",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX2030",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Ethernet Link مال CX2030 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX2030 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX2030 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX2030 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Module مفقود من تكوين CX2030",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX2030",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX2030",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Digital Input ما يقرا على CX2030",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Input على CX2030 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Output على CX2030 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Analog Input على CX2030 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Analog Input على CX2030 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Analog Reading على CX2030 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Analog Output من CX2030 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "High Speed Counter على CX2030 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Encoder ويا CX2030 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Force/Override فعال على CX2030",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX2030",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX2030 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Motion/Axis command من CX2030 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "PID داخل CX2030 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "CX2030 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "CX2030 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "بيانات داخل CX2030 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2030-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2030",
      code: null,
      title_ar: "Diagnostic/Event log مال CX2030 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2030",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2030", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "CX2033 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "CX2033 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "CX2033 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Watchdog مال CX2033 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Scan Time مال CX2033 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "حرارة CX2033 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Battery/Backup مال CX2033 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Memory Error في CX2033",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "بيانات Retain مال CX2033 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "ساعة RTC مال CX2033 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Firmware مال CX2033 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Project داخل CX2033 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Download إلى CX2033 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Upload من CX2033 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX2033",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX2033",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX2033",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Ethernet Link مال CX2033 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX2033 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX2033 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX2033 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Module مفقود من تكوين CX2033",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX2033",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX2033",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Digital Input ما يقرا على CX2033",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Input على CX2033 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Output على CX2033 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Analog Input على CX2033 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Analog Input على CX2033 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Analog Reading على CX2033 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Analog Output من CX2033 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "High Speed Counter على CX2033 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Encoder ويا CX2033 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Force/Override فعال على CX2033",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX2033",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX2033 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Motion/Axis command من CX2033 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "PID داخل CX2033 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "CX2033 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "CX2033 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "بيانات داخل CX2033 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2033-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2033",
      code: null,
      title_ar: "Diagnostic/Event log مال CX2033 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2033",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2033", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "CX2040 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "CX2040 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "CX2040 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Watchdog مال CX2040 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Scan Time مال CX2040 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "حرارة CX2040 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Battery/Backup مال CX2040 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Memory Error في CX2040",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "بيانات Retain مال CX2040 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "ساعة RTC مال CX2040 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Firmware مال CX2040 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Project داخل CX2040 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Download إلى CX2040 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Upload من CX2040 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX2040",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX2040",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX2040",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Ethernet Link مال CX2040 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX2040 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX2040 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX2040 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Module مفقود من تكوين CX2040",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX2040",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX2040",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Digital Input ما يقرا على CX2040",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Input على CX2040 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Output على CX2040 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Analog Input على CX2040 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Analog Input على CX2040 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Analog Reading على CX2040 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Analog Output من CX2040 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "High Speed Counter على CX2040 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Encoder ويا CX2040 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Force/Override فعال على CX2040",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX2040",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX2040 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Motion/Axis command من CX2040 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "PID داخل CX2040 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "CX2040 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "CX2040 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "بيانات داخل CX2040 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2040-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2040",
      code: null,
      title_ar: "Diagnostic/Event log مال CX2040 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2040",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2040", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "CX2042 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "CX2042 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "CX2042 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Watchdog مال CX2042 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Scan Time مال CX2042 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "حرارة CX2042 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Battery/Backup مال CX2042 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Memory Error في CX2042",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "بيانات Retain مال CX2042 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "ساعة RTC مال CX2042 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Firmware مال CX2042 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Project داخل CX2042 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Download إلى CX2042 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Upload من CX2042 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX2042",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX2042",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX2042",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Ethernet Link مال CX2042 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX2042 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX2042 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX2042 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Module مفقود من تكوين CX2042",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX2042",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX2042",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Digital Input ما يقرا على CX2042",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Input على CX2042 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Output على CX2042 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Analog Input على CX2042 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Analog Input على CX2042 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Analog Reading على CX2042 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Analog Output من CX2042 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "High Speed Counter على CX2042 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Encoder ويا CX2042 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Force/Override فعال على CX2042",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX2042",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX2042 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Motion/Axis command من CX2042 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "PID داخل CX2042 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "CX2042 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "CX2042 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "بيانات داخل CX2042 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2042-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2042",
      code: null,
      title_ar: "Diagnostic/Event log مال CX2042 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2042",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2042", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "CX2043 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "CX2043 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "CX2043 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Watchdog مال CX2043 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Scan Time مال CX2043 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "حرارة CX2043 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Battery/Backup مال CX2043 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Memory Error في CX2043",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "بيانات Retain مال CX2043 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "ساعة RTC مال CX2043 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Firmware مال CX2043 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Project داخل CX2043 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Download إلى CX2043 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Upload من CX2043 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX2043",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX2043",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX2043",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Ethernet Link مال CX2043 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX2043 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX2043 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX2043 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Module مفقود من تكوين CX2043",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX2043",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX2043",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Digital Input ما يقرا على CX2043",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Input على CX2043 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Output على CX2043 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Analog Input على CX2043 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Analog Input على CX2043 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Analog Reading على CX2043 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Analog Output من CX2043 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "High Speed Counter على CX2043 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Encoder ويا CX2043 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Force/Override فعال على CX2043",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX2043",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX2043 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Motion/Axis command من CX2043 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "PID داخل CX2043 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "CX2043 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "CX2043 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "بيانات داخل CX2043 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2043-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2043",
      code: null,
      title_ar: "Diagnostic/Event log مال CX2043 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2043",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2043", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "CX2062 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "CX2062 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "CX2062 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Watchdog مال CX2062 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Scan Time مال CX2062 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "حرارة CX2062 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Battery/Backup مال CX2062 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Memory Error في CX2062",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "بيانات Retain مال CX2062 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "ساعة RTC مال CX2062 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Firmware مال CX2062 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Project داخل CX2062 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Download إلى CX2062 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Upload من CX2062 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX2062",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX2062",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX2062",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Ethernet Link مال CX2062 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX2062 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX2062 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX2062 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Module مفقود من تكوين CX2062",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX2062",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX2062",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Digital Input ما يقرا على CX2062",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Input على CX2062 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Output على CX2062 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Analog Input على CX2062 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Analog Input على CX2062 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Analog Reading على CX2062 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Analog Output من CX2062 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "High Speed Counter على CX2062 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Encoder ويا CX2062 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Force/Override فعال على CX2062",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX2062",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX2062 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Motion/Axis command من CX2062 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "PID داخل CX2062 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "CX2062 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "CX2062 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "بيانات داخل CX2062 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2062-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2062",
      code: null,
      title_ar: "Diagnostic/Event log مال CX2062 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2062",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2062", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "CX2072 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "CX2072 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "CX2072 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Watchdog مال CX2072 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Scan Time مال CX2072 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "حرارة CX2072 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Battery/Backup مال CX2072 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Memory Error في CX2072",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "بيانات Retain مال CX2072 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "ساعة RTC مال CX2072 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Firmware مال CX2072 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Project داخل CX2072 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Download إلى CX2072 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Upload من CX2072 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX2072",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX2072",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX2072",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Ethernet Link مال CX2072 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX2072 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX2072 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX2072 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Module مفقود من تكوين CX2072",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX2072",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX2072",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Digital Input ما يقرا على CX2072",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Input على CX2072 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Output على CX2072 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Analog Input على CX2072 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Analog Input على CX2072 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Analog Reading على CX2072 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Analog Output من CX2072 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "High Speed Counter على CX2072 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Encoder ويا CX2072 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Force/Override فعال على CX2072",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX2072",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX2072 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Motion/Axis command من CX2072 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "PID داخل CX2072 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "CX2072 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "CX2072 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "بيانات داخل CX2072 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx2000-cx2072-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx2000",
      model: "CX2072",
      code: null,
      title_ar: "Diagnostic/Event log مال CX2072 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX2072",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX2000", "CX2072", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "CX7000 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "CX7000 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "CX7000 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Watchdog مال CX7000 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Scan Time مال CX7000 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "حرارة CX7000 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Battery/Backup مال CX7000 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Memory Error في CX7000",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "بيانات Retain مال CX7000 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "ساعة RTC مال CX7000 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Firmware مال CX7000 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Project داخل CX7000 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Download إلى CX7000 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Upload من CX7000 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX7000",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX7000",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX7000",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Ethernet Link مال CX7000 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX7000 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX7000 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX7000 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Module مفقود من تكوين CX7000",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX7000",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX7000",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Digital Input ما يقرا على CX7000",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Input على CX7000 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Output على CX7000 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Analog Input على CX7000 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Analog Input على CX7000 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Analog Reading على CX7000 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Analog Output من CX7000 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "High Speed Counter على CX7000 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Encoder ويا CX7000 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Force/Override فعال على CX7000",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX7000",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX7000 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Motion/Axis command من CX7000 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "PID داخل CX7000 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "CX7000 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "CX7000 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "بيانات داخل CX7000 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx7000-cx7000-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx7000",
      model: "CX7000",
      code: null,
      title_ar: "Diagnostic/Event log مال CX7000 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX7000",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX7000", "CX7000", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "CX8010 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "CX8010 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "CX8010 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Watchdog مال CX8010 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Scan Time مال CX8010 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "حرارة CX8010 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Battery/Backup مال CX8010 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Memory Error في CX8010",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "بيانات Retain مال CX8010 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "ساعة RTC مال CX8010 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Firmware مال CX8010 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Project داخل CX8010 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Download إلى CX8010 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Upload من CX8010 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8010",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8010",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8010",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Ethernet Link مال CX8010 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8010 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8010 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8010 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Module مفقود من تكوين CX8010",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8010",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8010",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8010",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Input على CX8010 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Output على CX8010 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Analog Input على CX8010 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Analog Input على CX8010 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Analog Reading على CX8010 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Analog Output من CX8010 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "High Speed Counter على CX8010 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Encoder ويا CX8010 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Force/Override فعال على CX8010",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8010",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8010 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Motion/Axis command من CX8010 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "PID داخل CX8010 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "CX8010 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "CX8010 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "بيانات داخل CX8010 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8010-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8010",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8010 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8010",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8010", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "CX8020 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "CX8020 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "CX8020 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Watchdog مال CX8020 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Scan Time مال CX8020 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "حرارة CX8020 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Battery/Backup مال CX8020 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Memory Error في CX8020",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "بيانات Retain مال CX8020 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "ساعة RTC مال CX8020 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Firmware مال CX8020 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Project داخل CX8020 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Download إلى CX8020 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Upload من CX8020 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8020",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8020",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8020",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Ethernet Link مال CX8020 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8020 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8020 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8020 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Module مفقود من تكوين CX8020",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8020",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8020",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8020",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Input على CX8020 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Output على CX8020 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Analog Input على CX8020 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Analog Input على CX8020 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Analog Reading على CX8020 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Analog Output من CX8020 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "High Speed Counter على CX8020 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Encoder ويا CX8020 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Force/Override فعال على CX8020",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8020",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8020 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Motion/Axis command من CX8020 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "PID داخل CX8020 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "CX8020 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "CX8020 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "بيانات داخل CX8020 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8020-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8020",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8020 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8020",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8020", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "CX8030 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "CX8030 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "CX8030 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Watchdog مال CX8030 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Scan Time مال CX8030 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "حرارة CX8030 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Battery/Backup مال CX8030 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Memory Error في CX8030",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "بيانات Retain مال CX8030 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "ساعة RTC مال CX8030 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Firmware مال CX8030 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Project داخل CX8030 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Download إلى CX8030 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Upload من CX8030 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8030",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8030",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8030",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Ethernet Link مال CX8030 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8030 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8030 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8030 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Module مفقود من تكوين CX8030",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8030",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8030",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8030",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Input على CX8030 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Output على CX8030 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Analog Input على CX8030 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Analog Input على CX8030 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Analog Reading على CX8030 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Analog Output من CX8030 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "High Speed Counter على CX8030 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Encoder ويا CX8030 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Force/Override فعال على CX8030",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8030",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8030 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Motion/Axis command من CX8030 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "PID داخل CX8030 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "CX8030 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "CX8030 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "بيانات داخل CX8030 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8030-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8030",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8030 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8030",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8030", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "CX8031 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "CX8031 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "CX8031 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Watchdog مال CX8031 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Scan Time مال CX8031 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "حرارة CX8031 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Battery/Backup مال CX8031 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Memory Error في CX8031",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "بيانات Retain مال CX8031 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "ساعة RTC مال CX8031 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Firmware مال CX8031 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Project داخل CX8031 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Download إلى CX8031 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Upload من CX8031 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8031",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8031",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8031",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Ethernet Link مال CX8031 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8031 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8031 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8031 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Module مفقود من تكوين CX8031",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8031",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8031",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8031",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Input على CX8031 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Output على CX8031 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Analog Input على CX8031 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Analog Input على CX8031 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Analog Reading على CX8031 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Analog Output من CX8031 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "High Speed Counter على CX8031 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Encoder ويا CX8031 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Force/Override فعال على CX8031",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8031",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8031 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Motion/Axis command من CX8031 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "PID داخل CX8031 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "CX8031 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "CX8031 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "بيانات داخل CX8031 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8031-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8031",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8031 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8031",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8031", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "CX8050 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "CX8050 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "CX8050 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Watchdog مال CX8050 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Scan Time مال CX8050 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "حرارة CX8050 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Battery/Backup مال CX8050 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Memory Error في CX8050",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "بيانات Retain مال CX8050 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "ساعة RTC مال CX8050 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Firmware مال CX8050 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Project داخل CX8050 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Download إلى CX8050 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Upload من CX8050 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8050",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8050",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8050",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Ethernet Link مال CX8050 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8050 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8050 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8050 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Module مفقود من تكوين CX8050",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8050",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8050",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8050",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Input على CX8050 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Output على CX8050 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Analog Input على CX8050 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Analog Input على CX8050 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Analog Reading على CX8050 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Analog Output من CX8050 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "High Speed Counter على CX8050 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Encoder ويا CX8050 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Force/Override فعال على CX8050",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8050",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8050 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Motion/Axis command من CX8050 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "PID داخل CX8050 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "CX8050 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "CX8050 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "بيانات داخل CX8050 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8050-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8050",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8050 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8050",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8050", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "CX8051 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "CX8051 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "CX8051 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Watchdog مال CX8051 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Scan Time مال CX8051 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "حرارة CX8051 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Battery/Backup مال CX8051 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Memory Error في CX8051",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "بيانات Retain مال CX8051 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "ساعة RTC مال CX8051 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Firmware مال CX8051 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Project داخل CX8051 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Download إلى CX8051 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Upload من CX8051 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8051",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8051",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8051",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Ethernet Link مال CX8051 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8051 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8051 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8051 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Module مفقود من تكوين CX8051",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8051",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8051",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8051",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Input على CX8051 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Output على CX8051 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Analog Input على CX8051 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Analog Input على CX8051 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Analog Reading على CX8051 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Analog Output من CX8051 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "High Speed Counter على CX8051 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Encoder ويا CX8051 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Force/Override فعال على CX8051",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8051",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8051 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Motion/Axis command من CX8051 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "PID داخل CX8051 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "CX8051 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "CX8051 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "بيانات داخل CX8051 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8051-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8051",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8051 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8051",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8051", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "CX8060 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "CX8060 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "CX8060 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Watchdog مال CX8060 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Scan Time مال CX8060 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "حرارة CX8060 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Battery/Backup مال CX8060 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Memory Error في CX8060",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "بيانات Retain مال CX8060 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "ساعة RTC مال CX8060 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Firmware مال CX8060 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Project داخل CX8060 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Download إلى CX8060 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Upload من CX8060 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8060",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8060",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8060",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Ethernet Link مال CX8060 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8060 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8060 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8060 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Module مفقود من تكوين CX8060",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8060",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8060",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8060",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Input على CX8060 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Output على CX8060 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Analog Input على CX8060 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Analog Input على CX8060 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Analog Reading على CX8060 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Analog Output من CX8060 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "High Speed Counter على CX8060 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Encoder ويا CX8060 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Force/Override فعال على CX8060",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8060",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8060 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Motion/Axis command من CX8060 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "PID داخل CX8060 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "CX8060 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "CX8060 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "بيانات داخل CX8060 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8060-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8060",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8060 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8060",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8060", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "CX8090 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "CX8090 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "CX8090 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Watchdog مال CX8090 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Scan Time مال CX8090 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "حرارة CX8090 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Battery/Backup مال CX8090 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Memory Error في CX8090",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "بيانات Retain مال CX8090 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "ساعة RTC مال CX8090 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Firmware مال CX8090 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Project داخل CX8090 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Download إلى CX8090 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Upload من CX8090 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8090",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8090",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8090",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Ethernet Link مال CX8090 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8090 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8090 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8090 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Module مفقود من تكوين CX8090",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8090",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8090",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8090",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Input على CX8090 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Output على CX8090 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Analog Input على CX8090 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Analog Input على CX8090 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Analog Reading على CX8090 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Analog Output من CX8090 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "High Speed Counter على CX8090 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Encoder ويا CX8090 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Force/Override فعال على CX8090",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8090",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8090 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Motion/Axis command من CX8090 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "PID داخل CX8090 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "CX8090 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "CX8090 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "بيانات داخل CX8090 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8090-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8090",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8090 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8090",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8090", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "CX8091 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "CX8091 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "CX8091 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Watchdog مال CX8091 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Scan Time مال CX8091 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "حرارة CX8091 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Battery/Backup مال CX8091 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Memory Error في CX8091",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "بيانات Retain مال CX8091 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "ساعة RTC مال CX8091 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Firmware مال CX8091 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Project داخل CX8091 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Download إلى CX8091 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Upload من CX8091 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8091",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8091",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8091",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Ethernet Link مال CX8091 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8091 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8091 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8091 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Module مفقود من تكوين CX8091",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8091",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8091",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8091",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Input على CX8091 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Output على CX8091 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Analog Input على CX8091 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Analog Input على CX8091 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Analog Reading على CX8091 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Analog Output من CX8091 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "High Speed Counter على CX8091 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Encoder ويا CX8091 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Force/Override فعال على CX8091",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8091",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8091 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Motion/Axis command من CX8091 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "PID داخل CX8091 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "CX8091 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "CX8091 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "بيانات داخل CX8091 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8091-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8091",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8091 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8091",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8091", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "CX8093 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "CX8093 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "CX8093 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Watchdog مال CX8093 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Scan Time مال CX8093 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "حرارة CX8093 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Battery/Backup مال CX8093 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Memory Error في CX8093",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "بيانات Retain مال CX8093 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "ساعة RTC مال CX8093 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Firmware مال CX8093 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Project داخل CX8093 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Download إلى CX8093 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Upload من CX8093 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8093",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8093",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8093",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Ethernet Link مال CX8093 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8093 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8093 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8093 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Module مفقود من تكوين CX8093",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8093",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8093",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8093",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Input على CX8093 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Output على CX8093 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Analog Input على CX8093 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Analog Input على CX8093 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Analog Reading على CX8093 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Analog Output من CX8093 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "High Speed Counter على CX8093 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Encoder ويا CX8093 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Force/Override فعال على CX8093",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8093",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8093 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Motion/Axis command من CX8093 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "PID داخل CX8093 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "CX8093 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "CX8093 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "بيانات داخل CX8093 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8093-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8093",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8093 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8093",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8093", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "CX8095 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "CX8095 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "CX8095 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Watchdog مال CX8095 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Scan Time مال CX8095 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "حرارة CX8095 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Battery/Backup مال CX8095 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Memory Error في CX8095",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "بيانات Retain مال CX8095 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "ساعة RTC مال CX8095 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Firmware مال CX8095 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Project داخل CX8095 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Download إلى CX8095 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Upload من CX8095 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8095",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8095",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 2 / TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8095",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Ethernet Link مال CX8095 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8095 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8095 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8095 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Module مفقود من تكوين CX8095",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8095",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8095",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8095",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Input على CX8095 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Output على CX8095 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Analog Input على CX8095 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Analog Input على CX8095 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Analog Reading على CX8095 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Analog Output من CX8095 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "High Speed Counter على CX8095 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Encoder ويا CX8095 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Force/Override فعال على CX8095",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8095",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8095 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Motion/Axis command من CX8095 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "PID داخل CX8095 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "CX8095 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "CX8095 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "بيانات داخل CX8095 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8000-cx8095-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8000",
      model: "CX8095",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8095 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8095",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8000", "CX8095", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "CX8100 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "CX8100 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "CX8100 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Watchdog مال CX8100 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Scan Time مال CX8100 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "حرارة CX8100 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Battery/Backup مال CX8100 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Memory Error في CX8100",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "بيانات Retain مال CX8100 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "ساعة RTC مال CX8100 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Firmware مال CX8100 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Project داخل CX8100 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Download إلى CX8100 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Upload من CX8100 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8100",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8100",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8100",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Ethernet Link مال CX8100 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8100 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8100 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8100 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Module مفقود من تكوين CX8100",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8100",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8100",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8100",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Input على CX8100 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Output على CX8100 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Analog Input على CX8100 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Analog Input على CX8100 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Analog Reading على CX8100 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Analog Output من CX8100 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "High Speed Counter على CX8100 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Encoder ويا CX8100 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Force/Override فعال على CX8100",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8100",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8100 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Motion/Axis command من CX8100 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "PID داخل CX8100 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "CX8100 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "CX8100 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "بيانات داخل CX8100 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8100-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8100",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8100 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8100",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8100", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "CX8110 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "CX8110 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "CX8110 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Watchdog مال CX8110 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Scan Time مال CX8110 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "حرارة CX8110 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Battery/Backup مال CX8110 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Memory Error في CX8110",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "بيانات Retain مال CX8110 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "ساعة RTC مال CX8110 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Firmware مال CX8110 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Project داخل CX8110 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Download إلى CX8110 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Upload من CX8110 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8110",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8110",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8110",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Ethernet Link مال CX8110 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8110 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8110 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8110 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Module مفقود من تكوين CX8110",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8110",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8110",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8110",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Input على CX8110 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Output على CX8110 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Analog Input على CX8110 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Analog Input على CX8110 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Analog Reading على CX8110 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Analog Output من CX8110 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "High Speed Counter على CX8110 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Encoder ويا CX8110 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Force/Override فعال على CX8110",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8110",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8110 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Motion/Axis command من CX8110 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "PID داخل CX8110 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "CX8110 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "CX8110 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "بيانات داخل CX8110 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8110-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8110",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8110 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8110",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8110", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "CX8120 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "CX8120 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "CX8120 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Watchdog مال CX8120 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Scan Time مال CX8120 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "حرارة CX8120 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Battery/Backup مال CX8120 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Memory Error في CX8120",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "بيانات Retain مال CX8120 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "ساعة RTC مال CX8120 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Firmware مال CX8120 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Project داخل CX8120 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Download إلى CX8120 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Upload من CX8120 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8120",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8120",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8120",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Ethernet Link مال CX8120 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8120 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8120 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8120 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Module مفقود من تكوين CX8120",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8120",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8120",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8120",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Input على CX8120 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Output على CX8120 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Analog Input على CX8120 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Analog Input على CX8120 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Analog Reading على CX8120 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Analog Output من CX8120 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "High Speed Counter على CX8120 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Encoder ويا CX8120 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Force/Override فعال على CX8120",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8120",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8120 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Motion/Axis command من CX8120 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "PID داخل CX8120 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "CX8120 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "CX8120 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "بيانات داخل CX8120 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8120-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8120",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8120 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8120",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8120", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "CX8190 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "CX8190 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "CX8190 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Watchdog مال CX8190 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Scan Time مال CX8190 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "حرارة CX8190 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Battery/Backup مال CX8190 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Memory Error في CX8190",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "بيانات Retain مال CX8190 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "ساعة RTC مال CX8190 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Firmware مال CX8190 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Project داخل CX8190 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Download إلى CX8190 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Upload من CX8190 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8190",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8190",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8190",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Ethernet Link مال CX8190 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8190 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8190 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8190 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Module مفقود من تكوين CX8190",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8190",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8190",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8190",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Input على CX8190 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Output على CX8190 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Analog Input على CX8190 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Analog Input على CX8190 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Analog Reading على CX8190 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Analog Output من CX8190 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "High Speed Counter على CX8190 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Encoder ويا CX8190 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Force/Override فعال على CX8190",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8190",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8190 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Motion/Axis command من CX8190 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "PID داخل CX8190 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "CX8190 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "CX8190 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "بيانات داخل CX8190 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8100-cx8190-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8100",
      model: "CX8190",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8190 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8190",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8100", "CX8190", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "CX8200 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "CX8200 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "CX8200 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Watchdog مال CX8200 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Scan Time مال CX8200 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "حرارة CX8200 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Battery/Backup مال CX8200 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Memory Error في CX8200",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "بيانات Retain مال CX8200 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "ساعة RTC مال CX8200 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Firmware مال CX8200 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Project داخل CX8200 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Download إلى CX8200 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Upload من CX8200 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8200",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8200",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8200",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Ethernet Link مال CX8200 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8200 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8200 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8200 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Module مفقود من تكوين CX8200",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8200",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8200",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8200",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Input على CX8200 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Output على CX8200 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Analog Input على CX8200 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Analog Input على CX8200 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Analog Reading على CX8200 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Analog Output من CX8200 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "High Speed Counter على CX8200 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Encoder ويا CX8200 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Force/Override فعال على CX8200",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8200",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8200 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Motion/Axis command من CX8200 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "PID داخل CX8200 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "CX8200 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "CX8200 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "بيانات داخل CX8200 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8200-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8200",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8200 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8200",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8200", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "CX8210 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "CX8210 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "CX8210 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Watchdog مال CX8210 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Scan Time مال CX8210 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "حرارة CX8210 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Battery/Backup مال CX8210 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Memory Error في CX8210",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "بيانات Retain مال CX8210 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "ساعة RTC مال CX8210 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Firmware مال CX8210 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Project داخل CX8210 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Download إلى CX8210 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Upload من CX8210 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8210",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8210",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8210",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Ethernet Link مال CX8210 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8210 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8210 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8210 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Module مفقود من تكوين CX8210",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8210",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8210",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8210",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Input على CX8210 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Output على CX8210 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Analog Input على CX8210 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Analog Input على CX8210 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Analog Reading على CX8210 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Analog Output من CX8210 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "High Speed Counter على CX8210 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Encoder ويا CX8210 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Force/Override فعال على CX8210",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8210",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8210 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Motion/Axis command من CX8210 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "PID داخل CX8210 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "CX8210 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "CX8210 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "بيانات داخل CX8210 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8210-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8210",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8210 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8210",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8210", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "CX8280 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "CX8280 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "CX8280 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Watchdog مال CX8280 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Scan Time مال CX8280 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "حرارة CX8280 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Battery/Backup مال CX8280 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Memory Error في CX8280",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "بيانات Retain مال CX8280 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "ساعة RTC مال CX8280 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Firmware مال CX8280 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Project داخل CX8280 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Download إلى CX8280 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Upload من CX8280 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8280",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8280",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8280",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Ethernet Link مال CX8280 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8280 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8280 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8280 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Module مفقود من تكوين CX8280",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8280",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8280",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8280",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Input على CX8280 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Output على CX8280 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Analog Input على CX8280 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Analog Input على CX8280 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Analog Reading على CX8280 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Analog Output من CX8280 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "High Speed Counter على CX8280 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Encoder ويا CX8280 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Force/Override فعال على CX8280",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8280",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8280 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Motion/Axis command من CX8280 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "PID داخل CX8280 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "CX8280 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "CX8280 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "بيانات داخل CX8280 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8280-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8280",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8280 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8280",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8280", "diagnostic log", "event log", "history"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-no-power",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "CX8290 ما يشتغل نهائياً",
      description_ar: "الـPLC ما يبين عليه تشغيل أو مؤشرات طاقة طبيعية.",
      symptoms: ["ماكو Power LED", "الـCPU ما يستجيب"],
      causes: [
        { cause: "فولت التغذية مفقود أو خارج المجال", probability: 40 },
        { cause: "فيوز أو قاطع السيطرة فاصل", probability: 25 },
        { cause: "ربط التغذية أو الـCommon مرخي", probability: 20 },
        { cause: "عطل داخلي بوحدة التغذية/CPU", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "افحص تغذية الـPLC والحماية والربطات حسب مواصفات الموديل. القياس الحي خليه لفني مؤهل.",
          normal: "الفولت ضمن مواصفة الموديل وPower LED بحالته الطبيعية.",
          faulty: "الفولت مفقود أو المؤشر ما يشتغل رغم توفر تغذية صحيحة.",
        },
      ],
      solutions: ["صحح مصدر التغذية أو الحماية.", "إذا التغذية سليمة افحص/بدل وحدة التغذية أو CPU حسب الدليل."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "power", "no power", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-stop-mode",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "CX8290 يبقى STOP وما يدخل RUN",
      description_ar: "الـCPU يبقى STOP أو يرجع STOP بعد محاولة التشغيل.",
      symptoms: ["RUN ما يثبت", "البرنامج ما ينفذ"],
      causes: [
        { cause: "Diagnostic fault مانع RUN", probability: 35 },
        { cause: "Hardware configuration مو مطابق", probability: 25 },
        { cause: "خطأ بالبرنامج", probability: 20 },
        { cause: "وضع التشغيل مو مضبوط", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "اقرأ Diagnostic Buffer أو Controller Diagnostics من برنامج البرمجة الخاص بالسلسلة قبل Reset.",
          normal: "الـCPU يدخل RUN بدون Diagnostic مانع التشغيل.",
          faulty: "يبقى STOP أو يرجع STOP ويظهر تشخيص.",
        },
      ],
      solutions: ["عالج أول Diagnostic Event.", "راجع وضع التشغيل والـHardware Configuration والبرنامج."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "stop", "run", "cpu mode", "diagnostic"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-unexpected-stop",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "CX8290 يدخل STOP/FAULT بشكل مفاجئ",
      description_ar: "الـPLC يشتغل وبعدها ينتقل إلى STOP أو Fault بدون أمر طبيعي.",
      symptoms: ["توقف مفاجئ", "Fault يتكرر بعد فترة"],
      causes: [
        { cause: "Watchdog أو Scan Time تجاوز الحد", probability: 30 },
        { cause: "خطأ برنامج غير معالج", probability: 25 },
        { cause: "فقدان Module/Remote I/O", probability: 25 },
        { cause: "تغذية أو اتصال غير مستقر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "سجل أول Diagnostic Event ووقت حدوثه قبل مسح العطل.",
          normal: "يبقى CPU بحالة RUN بدون Fault متكرر.",
          faulty: "يتكرر STOP/FAULT بنفس السبب.",
        },
      ],
      solutions: ["عالج أول حدث سبب التوقف.", "راجع Scan Time والاتصالات والموديولات والتغذية."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "fault", "unexpected stop", "watchdog"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-watchdog",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Watchdog مال CX8290 يتكرر",
      description_ar: "زمن تنفيذ البرنامج يتجاوز الحد أو يصير تعليق بدورة التنفيذ.",
      symptoms: ["Watchdog Fault", "توقف البرنامج"],
      causes: [
        { cause: "Loop طويل أو غير منتهي", probability: 35 },
        { cause: "Task/Interrupt مو مضبوط", probability: 25 },
        { cause: "اتصالات أو تعليمات ثقيلة", probability: 20 },
        { cause: "CPU load عالي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راقب Scan/Cycle Time وحدد الروتين اللي ترتفع وياها القيمة.",
          normal: "Cycle Time مستقر وأقل من الحد.",
          faulty: "Watchdog أو Cycle Time يقفز بشكل غير طبيعي.",
        },
      ],
      solutions: ["حسن البرنامج ووزع المهام.", "لا ترفع حد Watchdog عشوائياً قبل فهم السبب."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "watchdog", "scan time", "cycle"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-scan-time",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Scan Time مال CX8290 عالي",
      description_ar: "زمن الدورة أعلى من الطبيعي ويسبب بطء بالاستجابة.",
      symptoms: ["I/O يستجيب ببطء", "Cycle time مرتفع"],
      causes: [
        { cause: "منطق ثقيل", probability: 35 },
        { cause: "Loops أو معالجة arrays كبيرة", probability: 25 },
        { cause: "Communication blocks كثيرة", probability: 20 },
        { cause: "CPU غير مناسب للحمل", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راقب Cycle Time Online وقارن بين الروتينات أو المهام.",
          normal: "زمن الدورة ثابت ومناسب للتطبيق.",
          faulty: "زمن الدورة يرتفع أو يتذبذب بشكل كبير.",
        },
      ],
      solutions: ["خفف العمليات الثقيلة.", "وزع المهام أو استخدم CPU أعلى إذا التطبيق يتطلب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "scan", "performance", "cycle time"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-cpu-overtemp",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "حرارة CX8290 ترتفع",
      description_ar: "حرارة الـCPU أو اللوحة أعلى من الطبيعي.",
      symptoms: ["حرارة عالية", "ممكن Reset أو Fault"],
      causes: [
        { cause: "تهوية ضعيفة", probability: 35 },
        { cause: "حرارة محيط عالية", probability: 25 },
        { cause: "غبار/انسداد", probability: 20 },
        { cause: "عطل داخلي", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "افحص حرارة اللوحة والتهوية بدون لمس أجزاء حية.",
          normal: "الحرارة ضمن مواصفات المصنع.",
          faulty: "حرارة أعلى من المجال أو Fault حراري.",
        },
      ],
      solutions: ["حسن التهوية ونظف الغبار بعد العزل.", "إذا استمرت الحرارة افحص CPU/PSU."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "temperature", "overheat", "cpu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-battery",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Battery/Backup مال CX8290 ضعيف أو منتهي",
      description_ar: "الـPLC يعطي إنذار بطارية/Backup أو يفقد بيانات حسب تصميم الموديل.",
      symptoms: ["Battery warning", "فقدان بيانات بعد فصل الطاقة"],
      causes: [
        { cause: "البطارية ضعيفة", probability: 45 },
        { cause: "البطارية غير مركبة/موصولة", probability: 25 },
        { cause: "Backup device متضرر", probability: 20 },
        { cause: "إعداد retain/backup مو صحيح", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راجع حالة Battery/Backup ضمن Diagnostics حسب الموديل.",
          normal: "ماكو Battery alarm والبيانات المطلوبة تبقى محفوظة.",
          faulty: "Battery alarm فعال أو البيانات تضيع.",
        },
      ],
      solutions: ["بدل البطارية بالطريقة الموصى بيها إذا الموديل يستخدمها.", "راجع Retentive/Backup settings."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "battery", "backup", "retain"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-memory",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Memory Error في CX8290",
      description_ar: "الـCPU يسجل خطأ Memory أو ما يقبل المشروع بالصورة الطبيعية.",
      symptoms: ["Memory Error", "Download/boot يفشل"],
      causes: [
        { cause: "Memory Card متضررة", probability: 30 },
        { cause: "ذاكرة داخلية بيها خطأ", probability: 25 },
        { cause: "ملف مشروع غير صالح", probability: 25 },
        { cause: "Firmware/format mismatch", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "اقرأ Memory Diagnostics وافحص وسيلة الذاكرة حسب تعليمات الشركة.",
          normal: "الذاكرة تُقرأ بدون Error.",
          faulty: "Memory error يبقى فعال أو المشروع ما يقلع.",
        },
      ],
      solutions: ["أعد كتابة/تهيئة وسيلة الذاكرة إذا مسموح.", "استبدل الذاكرة/CPU إذا استمر الخطأ."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "memory", "card", "storage"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-retain",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "بيانات Retain مال CX8290 تضيع",
      description_ar: "القيم اللي لازم تبقى محفوظة ترجع Default بعد Restart.",
      symptoms: ["Setpoints ترجع", "Counters/values تضيع"],
      causes: [
        { cause: "Retentive range مو معرف", probability: 40 },
        { cause: "Battery/backup ضعيف", probability: 25 },
        { cause: "Warm/Cold restart behavior مو مفهوم", probability: 20 },
        { cause: "Download استبدل القيم", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راجع Retain settings وسلوك restart بالمشروع.",
          normal: "القيم المحددة تبقى بعد Restart.",
          faulty: "القيم ترجع Default.",
        },
      ],
      solutions: ["صحح Retain settings.", "راجع battery/backup وطريقة download."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "retain", "memory", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-rtc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "ساعة RTC مال CX8290 غلط",
      description_ar: "وقت وتاريخ الـPLC يتغير أو ينحرف.",
      symptoms: ["Timestamp غلط", "Events بوقت غير صحيح"],
      causes: [
        { cause: "RTC غير مضبوط", probability: 35 },
        { cause: "بطارية/backup ضعيف", probability: 25 },
        { cause: "Time sync/NTP مو مضبوط", probability: 25 },
        { cause: "Timezone غلط", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن وقت PLC ويا وقت مرجعي وراجع Time Sync settings.",
          normal: "الوقت ثابت ومتزامن.",
          faulty: "الوقت ينحرف أو يرجع لقيمة غلط.",
        },
      ],
      solutions: ["صحح NTP/Time Sync/Timezone.", "افحص backup إذا الساعة تضيع بعد فصل الطاقة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "rtc", "clock", "time", "ntp"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-firmware",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Firmware مال CX8290 مو متوافق",
      description_ar: "المشروع أو الموديولات ما تشتغل بسبب Firmware/Revision mismatch.",
      symptoms: ["Module mismatch", "Download مرفوض", "Feature مو متاحة"],
      causes: [
        { cause: "Firmware قديم/جديد مو متوافق", probability: 40 },
        { cause: "Project version مختلف", probability: 25 },
        { cause: "Module revision غير مدعوم", probability: 20 },
        { cause: "ملف firmware غير صحيح", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن Firmware/Revision مع Compatibility للمشروع والموديولات.",
          normal: "الإصدارات متوافقة.",
          faulty: "يبقى mismatch أو incompatibility.",
        },
      ],
      solutions: ["استخدم Firmware موصى به.", "خذ Backup قبل أي Firmware update."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "firmware", "revision", "compatibility"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-project-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Project داخل CX8290 مو نفس المشروع الحالي",
      description_ar: "Online/Offline comparison يبين اختلاف بين مشروع الكمبيوتر والـPLC.",
      symptoms: ["Online changes مختلفة", "Download/Upload confusion"],
      causes: [
        { cause: "تم تنزيل مشروع آخر", probability: 35 },
        { cause: "تعديلات Online غير محفوظة", probability: 25 },
        { cause: "النسخة الاحتياطية قديمة", probability: 20 },
        { cause: "Wrong controller selected", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "اعمل Compare Online/Offline قبل أي Download. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "المشروعين متطابقين.",
          faulty: "تظهر اختلافات بالبرنامج أو hardware.",
        },
      ],
      solutions: ["احفظ نسخة من Online أولاً.", "قرر النسخة الصحيحة قبل الاستبدال."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "project mismatch", "online offline", "compare"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-download-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Download إلى CX8290 يفشل",
      description_ar: "برنامج البرمجة ما يگدر ينزل المشروع للـPLC.",
      symptoms: ["Download Error", "Transfer يتوقف"],
      causes: [
        { cause: "اتصال غير مستقر", probability: 30 },
        { cause: "CPU state غير مناسبة", probability: 25 },
        { cause: "Firmware/project mismatch", probability: 25 },
        { cause: "صلاحيات أو password", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "اقرأ رسالة Download كاملة وافحص الاتصال والحالة والصلاحيات. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "التنزيل يكتمل بدون Error.",
          faulty: "Transfer يفشل أو يتوقف.",
        },
      ],
      solutions: ["عالج رسالة الخطأ نفسها.", "راجع firmware/cpu mode/password."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "download", "transfer", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-upload-fail",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Upload من CX8290 يفشل",
      description_ar: "ما تگدر تسحب البرنامج/المشروع من الـPLC.",
      symptoms: ["Upload مرفوض", "Online لكن upload ما يكتمل"],
      causes: [
        { cause: "Access protection", probability: 35 },
        { cause: "Project upload مو مدعوم بالكامل", probability: 25 },
        { cause: "اتصال يقطع", probability: 20 },
        { cause: "Memory/project issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راجع Access Level وUpload support للسلسلة. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "Upload يكتمل حسب قدرات الجهاز.",
          faulty: "Upload مرفوض أو ناقص.",
        },
      ],
      solutions: ["استخدم الصلاحيات الصحيحة.", "ثبت الاتصال قبل إعادة المحاولة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "upload", "access", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-password",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Password/Protection يمنع الدخول لـ CX8290",
      description_ar: "الـPLC يرفض Online actions بسبب حماية أو صلاحية.",
      symptoms: ["Access denied", "Download/Upload/Monitor مرفوض"],
      causes: [
        { cause: "Password protection فعال", probability: 50 },
        { cause: "User role ما عنده صلاحية", probability: 25 },
        { cause: "Protection level عالي", probability: 25 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راجع User/Protection settings ضمن البرنامج الرسمي.",
          normal: "المستخدم المصرح يگدر ينفذ العملية.",
          faulty: "Access denied يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم بيانات دخول مصرح بيها.", "لا تحاول تجاوز حماية الجهاز."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "password", "protection", "access"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-programming-connection",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "الكمبيوتر ما يتصل بـ CX8290",
      description_ar: "برنامج البرمجة ما يگدر يسوي Online ويا الـPLC.",
      symptoms: ["Device not found", "Timeout"],
      causes: [
        { cause: "IP/Address غلط", probability: 35 },
        { cause: "Interface/adapter مختار غلط", probability: 25 },
        { cause: "Cable/Switch مشكلة", probability: 20 },
        { cause: "Firewall/route", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راجع عنوان PLC وواجهة الاتصال والكيبل. برنامج البرمجة لهذه السلسلة: TwinCAT 3.",
          normal: "الجهاز يظهر Online.",
          faulty: "Timeout أو Device Not Found.",
        },
      ],
      solutions: ["صحح العنوان والواجهة.", "اختبر الاتصال بمسار معروف وسليم."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "online", "connection", "programming"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-ip-conflict",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "IP Address Conflict مرتبط بـ CX8290",
      description_ar: "أكو جهاز ثاني بالشبكة يستخدم نفس IP.",
      symptoms: ["اتصال يقطع", "Device conflict", "أجهزة تختفي"],
      causes: [
        { cause: "Duplicate IP", probability: 70 },
        { cause: "DHCP/Static mix", probability: 20 },
        { cause: "Wrong network setup", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "افحص IP/MAC للأجهزة على الشبكة.",
          normal: "كل جهاز عنده IP فريد.",
          faulty: "نفس IP مستخدم من جهازين.",
        },
      ],
      solutions: ["غيّر العنوان المتكرر.", "وثق خطة عناوين الشبكة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "ip conflict", "duplicate ip", "ethernet"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-network-link",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Ethernet Link مال CX8290 ما يشتغل",
      description_ar: "منفذ الشبكة ما يبين Link أو يقطع.",
      symptoms: ["Link LED OFF", "الاتصال منقطع"],
      causes: [
        { cause: "كيبل تالف", probability: 35 },
        { cause: "Switch port مشكلة", probability: 25 },
        { cause: "Port disabled/configured wrong", probability: 20 },
        { cause: "منفذ PLC متضرر", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "افحص Link LEDs والكيبل والـswitch.",
          normal: "Link ثابت.",
          faulty: "Link مفقود أو يقطع.",
        },
      ],
      solutions: ["بدل الكيبل/port للتجربة.", "راجع إعداد منفذ PLC."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "ethernet", "link", "network"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-industrial-protocol",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "اتصال البروتوكول الصناعي ويا CX8290 يفشل",
      description_ar: "اتصال PROFINET/EtherNet-IP/Modbus أو بروتوكول السلسلة مو مستقر.",
      symptoms: ["Device Offline", "Timeout", "Connection fault"],
      causes: [
        { cause: "عنوان/اسم جهاز غلط", probability: 30 },
        { cause: "Configuration mismatch", probability: 25 },
        { cause: "Network issue", probability: 25 },
        { cause: "Device not ready", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "حدد البروتوكول والجهاز الأول اللي يفصل من Diagnostics.",
          normal: "كل الأجهزة المطلوبة Online.",
          faulty: "Device/connection fault فعال.",
        },
      ],
      solutions: ["صحح العناوين والتكوين.", "افحص التغذية والكيبل والجهاز البعيد."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "profinet", "ethernet ip", "modbus", "communication"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-serial-comm",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Serial/RS-485/RS-232 ويا CX8290 ما يتصل",
      description_ar: "الاتصال التسلسلي يفشل أو يرجع بيانات غلط.",
      symptoms: ["Timeout", "CRC/Frame Error", "ماكو جواب"],
      causes: [
        { cause: "Baud/parity/stop bits غلط", probability: 35 },
        { cause: "A/B polarity أو wiring غلط", probability: 30 },
        { cause: "Address غلط", probability: 20 },
        { cause: "Termination/noise", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن إعدادات الطرفين والتوصيل.",
          normal: "الإعدادات متطابقة والاتصال ثابت.",
          faulty: "Timeout أو frame/CRC errors.",
        },
      ],
      solutions: ["صحح إعدادات الاتصال.", "راجع termination/shielding/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "serial", "rs485", "rs232", "modbus rtu"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-remote-io",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Remote I/O مرتبط بـ CX8290 Offline",
      description_ar: "محطة I/O بعيدة تختفي أو تدخل Fault.",
      symptoms: ["Remote station offline", "I/O values invalid"],
      causes: [
        { cause: "Power loss بالمحطة", probability: 30 },
        { cause: "Network cable/switch", probability: 25 },
        { cause: "Address/node mismatch", probability: 25 },
        { cause: "Module fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "حدد أول محطة Offline وافحص تغذيتها واتصالها.",
          normal: "كل remote I/O Online.",
          faulty: "محطة تبقى Offline.",
        },
      ],
      solutions: ["عالج تغذية/اتصال المحطة.", "راجع node/address/config."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "remote io", "distributed io", "offline"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-module-missing",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Module مفقود من تكوين CX8290",
      description_ar: "الـCPU يتوقع موديول مو موجود أو ما يرد.",
      symptoms: ["Missing module", "Configuration fault"],
      causes: [
        { cause: "موديول غير مركب", probability: 40 },
        { cause: "الموديول متضرر", probability: 25 },
        { cause: "Slot غلط", probability: 20 },
        { cause: "Backplane/contact issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن Hardware Configuration بالموديولات الفعلية.",
          normal: "كل الموديولات موجودة ومقبولة.",
          faulty: "Module Missing/Faulted.",
        },
      ],
      solutions: ["ثبت الموديول الصحيح بعد العزل.", "صحح التكوين إذا الموديول غير مطلوب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "module missing", "hardware configuration"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-module-mismatch",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Module type/revision mismatch ويا CX8290",
      description_ar: "نوع أو revision الموديول غير مطابق للمشروع.",
      symptoms: ["Module mismatch", "I/O unavailable"],
      causes: [
        { cause: "موديل مختلف", probability: 40 },
        { cause: "Revision غير مدعوم", probability: 30 },
        { cause: "Project config قديم", probability: 20 },
        { cause: "Wrong slot", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن Part Number/Revision بالمشروع.",
          normal: "الهوية متطابقة.",
          faulty: "Mismatch يبقى ظاهر.",
        },
      ],
      solutions: ["استخدم الموديول الصحيح أو عدل المشروع.", "راجع compatibility."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "module mismatch", "revision"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-backplane",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Backplane/Bus Fault مال CX8290",
      description_ar: "الاتصال بين CPU والموديولات المحلية مو طبيعي.",
      symptoms: ["عدة Modules Fault", "Bus/Backplane error"],
      causes: [
        { cause: "Backplane/rail contact ضعيف", probability: 30 },
        { cause: "Power overload", probability: 25 },
        { cause: "Module faulty", probability: 25 },
        { cause: "Connector damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "افصل الطاقة وافحص تثبيت الموديولات والـbackplane.",
          normal: "كل الموديولات تتعرف طبيعي.",
          faulty: "عدة موديولات تفقد بنفس الوقت.",
        },
      ],
      solutions: ["أعد تثبيت الموديولات بعد العزل.", "افحص power budget/backplane."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "backplane", "bus fault", "rack"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-digital-input",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Digital Input ما يقرا على CX8290",
      description_ar: "إشارة الحقل موجودة بس الـPLC ما يشوفها.",
      symptoms: ["Input bit ثابت", "LED input مو مطابق"],
      causes: [
        { cause: "Sensor/common power", probability: 30 },
        { cause: "Wrong address/channel", probability: 25 },
        { cause: "Input module fault", probability: 25 },
        { cause: "Wire open", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن LED القناة ويا Tag/Address Online.",
          normal: "تغير الحقل يظهر بالـPLC.",
          faulty: "الإشارة موجودة بالحقل بس ما تظهر بالبرنامج.",
        },
      ],
      solutions: ["صحح wiring/common/address.", "افحص الموديول والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "digital input", "di", "sensor"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-digital-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Digital Output ON بالبرنامج والحمل OFF",
      description_ar: "المنطق يطلب تشغيل الخرج لكن الحمل ما يشتغل.",
      symptoms: ["Output tag ON", "الحمل OFF"],
      causes: [
        { cause: "Output supply/common missing", probability: 30 },
        { cause: "Channel damaged", probability: 25 },
        { cause: "Load fuse/protection", probability: 25 },
        { cause: "Relay/contactor/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن Tag وLED الخرج ومسار الحمل.",
          normal: "البرنامج وLED والحمل متطابقة.",
          faulty: "البرنامج ON والحمل OFF.",
        },
      ],
      solutions: ["افحص تغذية الخرج والحماية.", "افحص relay/contactor/channel."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "digital output", "do", "relay"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-input-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Input على CX8290 يبقى ON",
      description_ar: "قناة الإدخال تبقى ON رغم تغير الحساس.",
      symptoms: ["Input stuck ON", "المنطق يبقى شايف إشارة"],
      causes: [
        { cause: "Sensor stuck", probability: 35 },
        { cause: "Short to supply", probability: 30 },
        { cause: "Wrong wiring", probability: 20 },
        { cause: "Input channel damaged", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "افصل إشارة الحقل حسب إجراء آمن وراقب القناة.",
          normal: "القناة تتغير حسب الحساس.",
          faulty: "تبقى ON رغم فصل الإشارة بطريقة آمنة.",
        },
      ],
      solutions: ["افحص الحساس والأسلاك.", "افحص القناة/الموديول."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "input stuck", "di"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-output-stuck",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Output على CX8290 يبقى ON",
      description_ar: "الخرج يبقى فعال رغم أمر OFF.",
      symptoms: ["الحمل يبقى مشتغل", "Output LED/voltage ما ينزل"],
      causes: [
        { cause: "Relay contact welded", probability: 40 },
        { cause: "Transistor output damaged", probability: 30 },
        { cause: "Forced output", probability: 20 },
        { cause: "Wiring bypass", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "افحص Force/Override أولاً ثم مسار الخرج بعد العزل.",
          normal: "الخرج يتبع الأمر.",
          faulty: "يبقى الحمل ON رغم OFF.",
        },
      ],
      solutions: ["ألغِ Force المصرح به.", "بدل الموديول/relay إذا contact welded."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "output stuck", "welded", "force"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-analog-input-zero",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Analog Input على CX8290 يقرأ صفر",
      description_ar: "القناة التناظرية تبقى صفر رغم وجود إشارة.",
      symptoms: ["AI = 0", "القيمة ما تتغير"],
      causes: [
        { cause: "Loop power missing", probability: 30 },
        { cause: "Wire open", probability: 25 },
        { cause: "Wrong mode 0-10V/4-20mA", probability: 25 },
        { cause: "Channel fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن القياس الحقيقي بإعداد القناة.",
          normal: "القراءة تتناسب مع الإشارة.",
          faulty: "القيمة صفر رغم وجود إشارة.",
        },
      ],
      solutions: ["صحح mode/wiring/power.", "افحص القناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "analog input", "ai", "4-20ma", "0-10v"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-analog-input-max",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Analog Input على CX8290 يقرأ Max/Overrange",
      description_ar: "القناة التناظرية تبقى أعلى المدى.",
      symptoms: ["Overrange", "القيمة Max"],
      causes: [
        { cause: "Signal أعلى من range", probability: 35 },
        { cause: "Wrong scaling", probability: 25 },
        { cause: "Wire fault", probability: 20 },
        { cause: "Wrong sensor type", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قِس الإشارة وقارنها بالـrange.",
          normal: "الإشارة ضمن المجال.",
          faulty: "الإشارة/القراءة خارج المجال.",
        },
      ],
      solutions: ["صحح scaling/range.", "افحص sensor/wiring."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "analog overrange", "ai"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-analog-noise",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Analog Reading على CX8290 تتذبذب",
      description_ar: "القيمة التناظرية بيها Noise أو تذبذب.",
      symptoms: ["Reading unstable", "PID يتحرك"],
      causes: [
        { cause: "Shielding/grounding", probability: 30 },
        { cause: "Cable قرب power/VFD", probability: 25 },
        { cause: "Sensor supply noise", probability: 25 },
        { cause: "Filter setting", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راقب raw value وافحص shielding ومسار الكيبل.",
          normal: "القراءة ثابتة ضمن تذبذب طبيعي.",
          faulty: "تذبذب كبير بدون تغير حقيقي.",
        },
      ],
      solutions: ["حسن shielding/grounding.", "أبعد signal cable وراجع filter."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "analog noise", "shield", "filter"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-analog-output",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Analog Output من CX8290 مو صحيح",
      description_ar: "خرج 0-10V أو 4-20mA مو مطابق للأمر.",
      symptoms: ["AO غلط", "Valve/VFD ما يستجيب صح"],
      causes: [
        { cause: "Wrong scaling", probability: 35 },
        { cause: "Wrong mode", probability: 25 },
        { cause: "Load/wiring issue", probability: 20 },
        { cause: "Channel damage", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن commanded value بالقياس الفعلي.",
          normal: "الخرج يتناسب مع الأمر.",
          faulty: "الخرج ثابت أو غلط.",
        },
      ],
      solutions: ["صحح mode/scaling.", "افحص الحمل والقناة."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "analog output", "ao", "4-20ma"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-hsc",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "High Speed Counter على CX8290 ما يعد مضبوط",
      description_ar: "عداد السرعة العالية يفقد نبضات أو يعطي قيمة غلط.",
      symptoms: ["Counts ناقصة/زايدة", "Speed reading غلط"],
      causes: [
        { cause: "Input wiring/noise", probability: 30 },
        { cause: "Wrong HSC config", probability: 30 },
        { cause: "Frequency فوق limit", probability: 25 },
        { cause: "Sensor signal level", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "قارن frequency الفعلية بإعداد HSC وحدود الموديل.",
          normal: "العد ثابت ويطابق المرجع.",
          faulty: "يفقد pulses أو يتجاوز limit.",
        },
      ],
      solutions: ["صحح HSC config.", "حسن signal wiring أو استخدم hardware مناسب."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "hsc", "high speed counter", "pulse"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-encoder",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Encoder ويا CX8290 يعطي Position غلط",
      description_ar: "إشارة A/B/Z أو position مو صحيحة.",
      symptoms: ["Position jumps", "Direction غلط"],
      causes: [
        { cause: "A/B swapped", probability: 30 },
        { cause: "PPR setting غلط", probability: 25 },
        { cause: "Shielding/noise", probability: 25 },
        { cause: "Encoder supply/wiring", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راقب A/B/Z وراجع PPR/direction.",
          normal: "الموضع يتحرك بسلاسة وبالاتجاه الصحيح.",
          faulty: "قفزات أو اتجاه غلط.",
        },
      ],
      solutions: ["صحح wiring/PPR.", "راجع shielding/supply."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "encoder", "position", "a b z"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-force",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Force/Override فعال على CX8290",
      description_ar: "قيمة I/O أو Tag مفروضة وتتجاهل المنطق الطبيعي.",
      symptoms: ["I/O ما يتبع البرنامج", "Force indicator active"],
      causes: [
        { cause: "Force متروك من الصيانة", probability: 70 },
        { cause: "Test mode", probability: 20 },
        { cause: "Override بالبرنامج", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راجع Force/Override tables من برنامج البرمجة.",
          normal: "ماكو Forces غير مطلوبة.",
          faulty: "Force فعال على نقطة مؤثرة.",
        },
      ],
      solutions: ["أزل Force فقط بعد التأكد من سلامة العملية.", "وثق أي Force مطلوب للاختبار."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "force", "override", "test mode"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-interlock",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Interlock يمنع تشغيل أمر من CX8290",
      description_ar: "الـPLC شغال بس المنطق يمنع الخرج بسبب شرط.",
      symptoms: ["Output ما يشتغل", "ماكو Hardware fault"],
      causes: [
        { cause: "Safety/Process interlock active", probability: 40 },
        { cause: "Permissive missing", probability: 30 },
        { cause: "Sequence condition مو متحقق", probability: 20 },
        { cause: "Wrong tag state", probability: 10 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راقب شروط الـrung/logic Online بدون تجاوز الحماية.",
          normal: "كل permissives المطلوبة متحققة.",
          faulty: "شرط interlock يبقى FALSE.",
        },
      ],
      solutions: ["عالج سبب الـinterlock.", "لا تتجاوز safety interlock كحل دائم."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "interlock", "permissive", "logic"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-safety",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Safety CPU/I/O مرتبط بـ CX8290 يدخل Fault",
      description_ar: "منظومة الـSafety تبقى Passivated/Faulted أو تمنع الحركة.",
      symptoms: ["Safety fault", "Outputs safety OFF"],
      causes: [
        { cause: "Safety input discrepancy", probability: 30 },
        { cause: "Safety communication fault", probability: 25 },
        { cause: "Safety address/signature/config mismatch", probability: 25 },
        { cause: "Safety device fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "اقرأ Safety Diagnostics الخاصة بالشركة ولا تتجاوز دائرة الأمان.",
          normal: "Safety system Healthy.",
          faulty: "Fault/Passivation يبقى فعال.",
        },
      ],
      solutions: ["عالج السبب من safety diagnostics.", "لا تعمل bypass لدائرة السلامة."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "safety", "fail safe", "profisafe", "cip safety"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-motion",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Motion/Axis command من CX8290 يفشل",
      description_ar: "أوامر الحركة/المحور ترجع Error أو ما تبدأ.",
      symptoms: ["Motion FB Error", "Axis not ready"],
      causes: [
        { cause: "Drive not ready", probability: 30 },
        { cause: "Axis config mismatch", probability: 25 },
        { cause: "Limit/interlock active", probability: 25 },
        { cause: "Network/encoder fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "اقرأ ErrorID/Axis Diagnostics.",
          normal: "المحور Ready ويقبل الأمر.",
          faulty: "ErrorID أو Axis Fault فعال.",
        },
      ],
      solutions: ["عالج drive/axis fault.", "راجع axis config والlimits."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "motion", "axis", "servo", "errorid"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-pid",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "PID داخل CX8290 غير مستقر",
      description_ar: "الحلقة تتذبذب أو الاستجابة بطيئة جداً.",
      symptoms: ["Oscillation", "Overshoot", "Slow response"],
      causes: [
        { cause: "Tuning غير مناسب", probability: 40 },
        { cause: "Sensor noise", probability: 25 },
        { cause: "Output saturation", probability: 20 },
        { cause: "Wrong scaling", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راقب PV/SP/OUT trends.",
          normal: "الـPV يتبع SP باستقرار.",
          faulty: "ذبذبة أو saturation مستمر.",
        },
      ],
      solutions: ["راجع scaling أولاً.", "أعد tuning بطريقة آمنة."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "pid", "tuning", "control loop"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-startup",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "CX8290 ما يقلع بصورة طبيعية بعد فصل الكهرباء",
      description_ar: "بعد رجوع الطاقة يبقى CPU أو العملية بحالة غير متوقعة.",
      symptoms: ["Startup sequence يفشل", "Outputs ما ترجع مثل المطلوب"],
      causes: [
        { cause: "Startup mode/config", probability: 30 },
        { cause: "Retain data غير صحيحة", probability: 25 },
        { cause: "Remote devices مو جاهزة", probability: 25 },
        { cause: "Power sequencing", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راجع startup diagnostics وتسلسل جاهزية الأجهزة.",
          normal: "الـCPU والمنظومة يرجعن للحالة المصممة.",
          faulty: "startup يبقى متوقف.",
        },
      ],
      solutions: ["صحح startup logic/retentive states.", "راجع power sequencing."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "startup", "power cycle", "restart"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-random-reset",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "CX8290 يسوي Reset عشوائي",
      description_ar: "الـCPU يعيد تشغيل نفسه بدون أمر.",
      symptoms: ["Restart عشوائي", "Logs تنقطع"],
      causes: [
        { cause: "Power dips", probability: 35 },
        { cause: "EMI/noise", probability: 25 },
        { cause: "Overtemperature", probability: 20 },
        { cause: "CPU hardware fault", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "راقب power quality وdiagnostic timestamps.",
          normal: "ماكو resets غير مفسرة.",
          faulty: "restart يتكرر بدون أمر.",
        },
      ],
      solutions: ["عالج power/EMI/temperature.", "إذا مستمر افحص CPU hardware."],
      severity: "حرجة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "reset", "reboot", "power dip"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-data-corruption",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "بيانات داخل CX8290 تتغير بصورة غير منطقية",
      description_ar: "Tags/Data Blocks تتغير بدون سبب واضح.",
      symptoms: ["قيم غريبة", "Sequence ينهار"],
      causes: [
        { cause: "Indirect addressing غلط", probability: 30 },
        { cause: "Overwrite بالبرنامج", probability: 30 },
        { cause: "Communication write خارجي", probability: 20 },
        { cause: "Memory issue", probability: 20 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "استخدم cross-reference/watch/trace لتحديد من يكتب على المتغير.",
          normal: "القيمة تتغير من مصادر معروفة فقط.",
          faulty: "Writes غير متوقعة.",
        },
      ],
      solutions: ["صحح addressing/logic.", "راجع HMI/SCADA/communications writes."],
      severity: "عالية",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "data corruption", "tag overwrite", "memory"],
    },
    {
      id: "beckhoff-beckhoff-cx8200-cx8290-diag-log",
      manufacturer_id: "beckhoff",
      series_id: "beckhoff-cx8200",
      model: "CX8290",
      code: null,
      title_ar: "Diagnostic/Event log مال CX8290 مليان أو الأحداث كثيرة",
      description_ar: "السجل يتكرر بسرعة ويصعب تحديد السبب الأصلي.",
      symptoms: ["Events كثيرة", "نفس fault يتكرر"],
      causes: [
        { cause: "Fault متقطع غير معالج", probability: 45 },
        { cause: "Network flapping", probability: 25 },
        { cause: "Sensor chatter", probability: 15 },
        { cause: "Time sync issue", probability: 15 },
      ],
      tests: [
        {
          test: "الفحص التشخيصي",
          location: "CX8290",
          method: "فلتر السجل حسب الوقت وحدد أول حدث.",
          normal: "الأحداث محدودة ومفهومة.",
          faulty: "نفس fault يتكرر بصورة مستمرة.",
        },
      ],
      solutions: ["عالج أول سبب.", "لا تمسح السجل قبل حفظه."],
      severity: "متوسطة",
      safety_warnings: [
        "لا تتجاوز دوائر الحماية أو Safety Interlock حتى تختبر الـPLC.",
        "قبل فك الأسلاك أو الموديولات اعزل الطاقة. القياسات الحية خلهن لفني مؤهل.",
      ],
      keywords: ["Beckhoff", "CX8200", "CX8290", "diagnostic log", "event log", "history"],
    },
  ],
};
